import { render, staticRenderFns } from "./OnDemand.vue?vue&type=template&id=05a494d2&scoped=true&"
import script from "./OnDemand.vue?vue&type=script&lang=js&"
export * from "./OnDemand.vue?vue&type=script&lang=js&"
import style0 from "./OnDemand.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OnDemand.vue?vue&type=style&index=1&id=05a494d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a494d2",
  null
  
)

export default component.exports